var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 39.2C20 32.4794 20 29.1191 21.3079 26.5521C22.4584 24.2942 24.2942 22.4584 26.5521 21.3079C29.1191 20 32.4794 20 39.2 20H80.8C87.5206 20 90.8809 20 93.4479 21.3079C95.7058 22.4584 97.5416 24.2942 98.6921 26.5521C100 29.1191 100 32.4794 100 39.2V80.8C100 87.5206 100 90.8809 98.6921 93.4479C97.5416 95.7058 95.7058 97.5416 93.4479 98.6921C90.8809 100 87.5206 100 80.8 100H39.2C32.4794 100 29.1191 100 26.5521 98.6921C24.2942 97.5416 22.4584 95.7058 21.3079 93.4479C20 90.8809 20 87.5206 20 80.8V39.2Z",
    fill: "#FCF5EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7599 66.7105C56.9136 68.3852 58.3183 69.6668 60 69.6668C61.6818 69.6668 63.0864 68.3852 63.2402 66.7105L65.3385 43.8509C65.6268 40.7099 63.1543 38 60 38C56.8458 38 54.3732 40.7099 54.6616 43.8509L56.7599 66.7105Z",
    fill: "url(#paint0_linear_532_17624)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6886 77.6886C55.6886 80.0698 57.6189 82.0001 60 82.0001C62.3812 82.0001 64.3115 80.0698 64.3115 77.6886C64.3115 75.3075 62.3812 73.3772 60 73.3772C57.6189 73.3772 55.6886 75.3075 55.6886 77.6886Z",
    fill: "url(#paint1_linear_532_17624)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_532_17624",
    x1: 60,
    y1: 38,
    x2: 60,
    y2: 82.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDAA8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC886E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_532_17624",
    x1: 60,
    y1: 38,
    x2: 60,
    y2: 82.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDAA8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC886E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningLarge);
export default __webpack_public_path__ + "static/media/warningLarge.d871fc2f42e3bdbee35d30378e021d23.svg";
export { ForwardRef as ReactComponent };